import { ActionWord } from "@app/shared/resources/action-word";
import { HttpResponseHandler } from "@app/shared/services/http-response-handler";
import { createNoPropsAction, createRequestAction } from "./action-creators";

export interface SnackbarParams {
    message?: HttpResponseHandler;
    path?: string;
    buttonText?: string;
    duration?: number;
    stayAlive?: boolean;
}

const category = "Snackbar";
export const openSnackbar = createRequestAction<SnackbarParams>(category, ActionWord.created);
export const emptyAction = createNoPropsAction(`Empty ${category}`, ActionWord.created);
